import Splide from '@splidejs/splide';

function splideCarousel() {

    //console.log('splideCarousel');

    const carousels = document.querySelectorAll('.carousel');

    carousels.forEach((carousel) => {

        const splideElement = carousel.querySelector('.splide');
        const counter = carousel.querySelector('.carousel__progress__counter');
        const bar = carousel.querySelector('.carousel__progress__bar');

        if (!splideElement) return;

        // Configuración por tipo
        let splideOptions = {
            autoplay: true,
            type: 'loop',
            autoWidth: true,
            arrows: false,
            pagination: false,
            interval: 5000,
            perMove: 1,
            gap: '20px', // Espacio entre slides en móvil
            breakpoints: {
                768: {
                    gap: '25px', // Espacio entre slides en móvil
                }
            }
        };

        const splide = new Splide(splideElement, splideOptions);

        function updateCounter() {
            if (counter) {
                counter.textContent = `${splide.index + 1} of ${splide.length}`;
            }
        }

        splide.on('mounted move', function () {
            var end = splide.Components.Controller.getEnd() + 1;
            var rate = Math.min((splide.index + 1) / end, 1);
            if (bar) bar.style.width = String(100 * rate) + '%';
            updateCounter();
        });

        splide.mount();

    });
}

export default splideCarousel;